import { useFpB2bButlerService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-butler-service'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import Error from '../../assets/icons/error.svg?react'
import { useButler } from '../ButlerProvider/useButler'

const styles = stylex.create({
  body: {
    gap: 8,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: 'calc(100vh - 56px)',
  },
  button: {
    backgroundColor: colors.black,
  },
  text: {
    paddingBlock: '16px',
  },
})

export const AiAnalysisError = () => {
  const { campaignId, platform, selectedTab } = useButler()
  const { resetButler, resetOrderStatus, isOrderStatusIncorrectFormat } = useFpB2bButlerService(campaignId, platform)

  const handleCancelClick = () => {
    resetButler({ selectedTab })
    resetOrderStatus()
  }

  const errorTitle = isOrderStatusIncorrectFormat ? 'PDF 格式錯誤' : '發生未知的錯誤'

  return (
    <Box rootStyle={styles.body}>
      <Box pl={3}>
        <Error />
      </Box>
      <Text variant="h5" rootStyle={styles.text}>{errorTitle}</Text>
      <Button rootStyle={styles.button} onClick={handleCancelClick}>回上一步</Button>
    </Box>
  )
}
